<template>
    <div class="tw-mt-10">
        <loading-custom :loading="loading" />
        <form @submit.prevent="handleSubmit()">
            <template v-if="data">
                <div>
                    <h2>{{ title }}</h2>
                    <p>{{ description }}</p>
                </div>
                <div class="row">
                    <template>
                        <div
                            v-for="(item, index) in data"
                            :class="
                                `${
                                    item.type != 'textarea' ? 'col-lg-6' : ''
                                } col-12 tw-my-2 ${
                                    error[item.input] ? 'error-active' : ''
                                }`
                            "
                            :key="index"
                        >
                            <label class="tw-text-gray-500" for="">
                                {{ item.input }}
                                <span
                                    class="tw-text-red-500"
                                    v-if="item.required"
                                    >* จำเป็นต้องกรอก</span
                                >
                            </label>
                            <input
                                v-if="item.type == 'text'"
                                type="text"
                                class="form-control"
                                :placeholder="`กรุณากรอก${item.input}`"
                                v-model="form[item.input]"
                            />
                            <select
                                v-else-if="item.type == 'list'"
                                class="form-control"
                                :placeholder="`กรุณากรอก${item.input}`"
                                v-model="form[item.input]"
                            >
                                <option hidden value="">
                                    {{ `กรุณากรอก${item.input}` }}
                                </option>
                                <option
                                    v-for="(itemList, listIndex) in item.list"
                                    :key="`list-${listIndex}`"
                                    :value="itemList"
                                >
                                    {{ itemList }}
                                </option>
                            </select>
                            <textarea
                                v-else-if="item.type == 'textarea'"
                                class="form-control"
                                v-model="form[item.input]"
                                :placeholder="`กรุณากรอก${item.input}`"
                                cols="30"
                                rows="10"
                            ></textarea>
                            <div
                                class="form-date"
                                v-else-if="item.type == 'date'"
                            >
                                <date-picker
                                    v-model="form[item.input]"
                                    type="date"
                                    placeholder="เลือกวันที่"
                                    format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD"
                                    valueType
                                >
                                </date-picker>
                            </div>
                            <div
                                class="tw-text-red-500 tw-ml-2 tw-mt-2"
                                v-if="error[item.input]"
                            >
                                {{ error[item.input]["message"] }}
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <div class="tw-flex tw-justify-between tw-items-center">
                <button class="btn btn-success" type="submit">
                    ส่ง
                </button>
                <span @click="clearForm" class="tw-cursor-pointer"
                    >ล้างฟอร์ม</span
                >
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            required: true
        },
        description: {
            required: false
        },
        shop: {
            required: true
        },
        formBodies: {
            required: true
        },
        salepage_id: {
            required: true
        },
        base_url: {
            required: false
        }
    },
    data() {
        return {
            api_url: this.base_url || "",
            data: [],
            form: {},
            error: {},
            loading: false
        };
    },
    watch: {
        formBodies: function(val) {
            this.setFormBodies(this.formBodies);
        }
    },
    mounted() {
        this.setFormBodies(this.formBodies);
    },
    methods: {
        clearForm() {
            this.setFormBodies(this.formBodies);
        },
        async setFormBodies(formBodies) {
            this.form = {};
            if (formBodies) {
                formBodies.forEach(item => {
                    Vue.set(this.form, item.input, "");
                });
                this.data = await formBodies;
            }
        },
        checkRequired() {
            let rs = false;
            let requiredInput = _.filter(this.data, item => {
                return item.required == true;
            });

            requiredInput.map(item => {
                if (!this.form[item.input]) {
                    Vue.set(this.error, item.input, {
                        message: `กรุณากรอก${item.input}`
                    });
                    rs = true;
                }
            });
            if (rs) {
                setTimeout(() => {
                    this.error = {};
                }, 3000);
            }
            return rs;
        },
        handleSubmit() {
            if (!this.checkRequired()) {
                this.saveForm();
            }
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        async saveForm() {
            this.loading = true;
            this.form.utm = this.getQuery();
            await axios
                .post(
                    `/ajax/frontend/s/${this.shop}/salepage/${this.salepage_id}/forms`,
                    this.form
                )
                .then(res => {
                    this.setFormBodies(this.formBodies);
                    this.$swal({
                        icon: "success",
                        title: res.data.message_text,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert("error", "Sorry", "เกิดข้อผิดพลาด");
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss">
.form-date {
    .mx-datepicker {
        width: 100% !important;
        input {
            display: block;
            width: 100%;
            height: calc(1.6em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 0.9rem;
            font-weight: 400;
            line-height: 1.6;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out,
                box-shadow 0.15s ease-in-out;
            box-shadow: unset;
        }
    }
}
.error-active {
    input {
        border: 1px solid red;
        transition: all 0.5s ease;
    }
}
</style>
